var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "DashboardBox", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-6", attrs: { cols: "12" } },
            [
              _c(
                "v-container",
                {
                  staticClass: "blue-grey lighten-4 titleDashboard elevation-1",
                  attrs: { fluid: "" }
                },
                [_c("h2", {}, [_vm._v("Tickets")])]
              ),
              _c("TicketDataTable", {
                attrs: {
                  headers: _vm.headersTicketsDayco,
                  items: _vm.tickets,
                  id: "dataTableTicket",
                  "hide-default-footer": ""
                },
                on: {
                  getFiltersTicketMenu: _vm.getFiltersTicketMenu,
                  getItemsPerPage: _vm.getItemsPerPage
                }
              }),
              _c(
                "div",
                { staticClass: "blue-grey lighten-4 ma-0 py-2" },
                [
                  _c("v-pagination", {
                    attrs: {
                      length: _vm.pagesTicketsDayco,
                      "total-visible": 7
                    },
                    on: {
                      input: function($event) {
                        return _vm.changePageTicketsDayco()
                      }
                    },
                    model: {
                      value: _vm.pageTicketsDayco,
                      callback: function($$v) {
                        _vm.pageTicketsDayco = $$v
                      },
                      expression: "pageTicketsDayco"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }